import React from "react";

const JobDetailsDialog = ({ details }) => {
  return (
    <>
      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2777AA" }}>
        Job Title
      </div>
      <div>{details.title}</div>
      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2777AA" }}>
        Job Description
      </div>
      <div dangerouslySetInnerHTML={{ __html: details.job_description }} />
      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2777AA" }}>
        Core Skill
      </div>
      <div>{details?.jobCoreSkill?.name || ""}</div>
    </>
  );
};

export default JobDetailsDialog;
